"use client";

import { useState } from "react";
import {
  Tabs,
  Tab,
  Card,
  CardContent,
  Typography,
  Container,
} from "@mui/material";
import { apps } from "@/constants/apps.constant";

export default function Page() {
  const [parent, setParent] = useState(apps[0]?.id || "");

  return (
    <main>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h5" className="font-semibold" gutterBottom>
          DJI Apps
        </Typography>

        <Tabs
          value={parent}
          onChange={(_, newValue) => setParent(newValue)}
          textColor="inherit"
          indicatorColor="primary"
          className="mb-4"
        >
          {apps.map((app) => (
            <Tab key={app.id} label={app.name} value={app.id} />
          ))}
        </Tabs>

        {apps
          .filter((d) => d.id === parent)
          .map((app, index) => (
            <div
              key={index}
              className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4"
            >
              {app.apps.map((value) => (
                <a
                  key={value.id}
                  href={value.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Card sx={{ "&:hover": { boxShadow: 8 } }}>
                    <CardContent>
                      <figure className="mb-3">
                        <img
                          src={value.image}
                          alt={value.name}
                          width={40}
                          height={40}
                        />
                      </figure>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {value.name}
                      </Typography>
                      <Typography variant="body2" className="line-clamp-3">
                        {value.para}
                      </Typography>
                    </CardContent>
                  </Card>
                </a>
              ))}
            </div>
          ))}
      </Container>
    </main>
  );
}
